interface ModuleItem {
  name: string;
  description: string;
}

interface ModuleCategory {
  title: string;
  items: ModuleItem[];
}

const CATEGORIES: ModuleCategory[] = [
  {
    title: 'Producción',
    items: [
      { name: 'Órdenes de Producción', description: 'Creación, seguimiento y datos completos de cada orden, con importación desde tu ERP.' },
      { name: 'Ejecución de Planta', description: 'Interfaz táctil para operadores: procesos, checklist y captura de evidencia en piso.' },
      { name: 'Cierre de Producción', description: 'Cierre formal de órdenes completadas con peso final, mermas y observaciones.' },
      { name: 'Visor 360', description: 'Monitor en tiempo real de la actividad de producción, orden por orden.' },
      { name: 'Lista Maestra', description: 'Tabla consolidada de todas las órdenes, filtrable y exportable.' },
    ],
  },
  {
    title: 'Planeación',
    items: [
      { name: 'Tablero de Planeación', description: 'Vista Kanban y Gantt para programar y reasignar órdenes entre máquinas.' },
      { name: 'Indicadores', description: 'KPIs filtrables por fecha, cliente y producto.' },
      { name: 'Dashboard', description: 'Resumen ejecutivo de estatus, volumen y carga de equipos.' },
    ],
  },
  {
    title: 'Especialidades',
    items: [
      { name: 'Diseño', description: 'Gestión de artes y diseños asociados a cada producto.' },
      { name: 'Órdenes de Grabado', description: 'Especificaciones y documentación de grabado de cilindros.' },
      { name: 'Coextrusión', description: 'Órdenes y recetas históricas de coextrusión.' },
    ],
  },
  {
    title: 'Administración',
    items: [
      { name: 'Catálogos', description: 'Equipos, procesos, colores, clientes, productos y rutas de fabricación.' },
      { name: 'Usuarios y Roles', description: 'Control de acceso con permisos granulares por rol.' },
      { name: 'Auditoría', description: 'Bitácora inmutable de toda la actividad del sistema.' },
      { name: 'Configuración', description: 'Integración con tu ERP, correo saliente y el asistente de IA.' },
    ],
  },
];

export default function ModulesSection() {
  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Un sistema, toda tu operación
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            De la planeación al cierre de cada orden, QPulseMES cubre cada paso de tu manufactura.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {CATEGORIES.map((category) => (
            <div key={category.title}>
              <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">
                {category.title}
              </h3>
              <div className="grid sm:grid-cols-2 gap-4">
                {category.items.map((item) => (
                  <div key={item.name} className="bg-gray-50 p-4 rounded-xl">
                    <div className="flex items-center gap-2 mb-1">
                      <svg className="w-4 h-4 text-blue-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="font-semibold text-gray-900 text-sm">{item.name}</span>
                    </div>
                    <p className="text-gray-600 text-xs leading-relaxed">{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}